/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { TableControlContext } from "@src/shipments/context/TableControlContext";
import { ShipmentsTableProvider } from "@src/shipments/context/ShipmentsTableContext";
import { ModalsProvider } from "@src/shipments/context/ShipmentsTableModalsContext";
import { ShipmentFiltersProvider } from "@src/shipments/context/ShipmentFiltersContext";
import { SavedViewPage } from "@api/graphql/generated/generated-types";
import { SavedViewsProvider } from "@src/common/components/SavedViews";
import { useFilterMapping } from "@src/shipments/context/SavedViews";
import { RestoringViewProvider } from "@src/shipments/context/RestoringViewContext";
import { ShipmentsCoreDataProvider } from "@src/shipments/context/ShipmentsCoreData";
import { ShipmentSelectionProvider } from "@src/shipments/context/ShipmentSelectionContext";
import { DispatchPreviewProvider } from "@src/shipments/context/DispatchPreviewContext";
import { ShipmentKeyboardControlProvider } from "@src/shipments/context/ShipmentKeyboardControlContext";
import OrdersPage from "@src/shipments/components/OrdersPage/OrdersPage";

function orders() {
  return (
    <TableControlContext sortKey="orders">
      <RestoringViewProvider>
        <ShipmentFiltersProvider>
          <SavedViewsProvider
            page={SavedViewPage.Orders}
            useViewMapping={useFilterMapping}
          >
            <ShipmentsCoreDataProvider>
              <DispatchPreviewProvider>
                <ShipmentSelectionProvider>
                  <ShipmentKeyboardControlProvider>
                    <ShipmentsTableProvider>
                      <ModalsProvider>
                        <OrdersPage />
                      </ModalsProvider>
                    </ShipmentsTableProvider>
                  </ShipmentKeyboardControlProvider>
                </ShipmentSelectionProvider>
              </DispatchPreviewProvider>
            </ShipmentsCoreDataProvider>
          </SavedViewsProvider>
        </ShipmentFiltersProvider>
      </RestoringViewProvider>
    </TableControlContext>
  );
}

export default orders;
